import { defineComponent as o, createElementBlock as r, openBlock as s, normalizeClass as n, unref as t, renderSlot as c } from "vue";
import { cva as l, cx as i } from "@scalar/use-hooks/useBindCx";
const p = ["aria-selected"], b = /* @__PURE__ */ o({
  __name: "ScalarComboboxOption",
  props: {
    active: { type: Boolean },
    selected: { type: Boolean }
  },
  setup(d) {
    const a = l({
      base: [
        // Group
        "group/item",
        // Layout
        "flex min-w-0 items-center gap-1.5 rounded px-2 py-1.5 text-left",
        // Text / background style
        "truncate bg-transparent text-c-1",
        // Interaction
        "cursor-pointer hover:bg-b-2"
      ],
      variants: {
        selected: { true: "text-c-1" },
        active: { true: "bg-b-2" }
      }
    });
    return (e, m) => (s(), r("li", {
      "aria-selected": e.selected,
      class: n(t(i)(t(a)({ active: e.active, selected: e.selected }))),
      role: "option",
      tabindex: "-1"
    }, [
      c(e.$slots, "default", {
        active: e.active,
        selected: e.selected
      })
    ], 10, p));
  }
});
export {
  b as default
};
